module.exports = __webpack_public_path__ + "static/media/truck.612f9a94.svg";